import { Controller, Post, Body, HttpException, HttpStatus } from '@nestjs/common';
import { AuthService } from './auth.service';
import { CreateUserDto, LoginUserDto, updateUserDto, UpdateUserDto } from '../user/dto/user.dto'
import { RegistrationStatus } from '../user/dto/registraton.dto';
import { ApiTags } from '@nestjs/swagger';
import { UserRequest } from '../user/dto/user.request';
import { UserResponseModel } from '@analytics-soa/shared-models';

@ApiTags('Auth')
@Controller('auth')
export class AuthController {
  constructor(private readonly authService: AuthService) { }
  @Post('register')
  public async register(@Body() createUserDto: CreateUserDto,): Promise<RegistrationStatus> {
    const result:
      RegistrationStatus = await this.authService.register(createUserDto,);
    if (!result.success) {
      throw new HttpException(result.message, HttpStatus.BAD_REQUEST);
    }
    console.log(result);
    return result;
  }
  // @Post('updateUser')  
  // public async updateUser(@Body() updateUserDto: updateUserDto,  ): Promise<RegistrationStatus> {    
  //   const result: 
  //   RegistrationStatus = await this.authService.updateUser(updateUserDto,);
  //   if (!result.success) {
  //       throw new HttpException(result.message, HttpStatus.BAD_REQUEST);    
  //   }
  //   console.log(result);
  //   return result;  
  // }
  @Post('login')
  public async login(@Body() loginUserDto: LoginUserDto): Promise<any> {
    // console.log(loginUserDto);
    try {
      return await this.authService.login(loginUserDto);
    } catch (error) {
      return error;
      // return new ProjectsResponseModel(1234, 'hii');
    }
  }
  @Post('getAllUsers')
  public async getAllUsers(): Promise<LoginUserDto> {
    // console.log(loginUserDto);
    return await this.authService.getAllUsers();
  }

  @Post('updateUser')
  public async updateUser(@Body() createUserDto: updateUserDto): Promise<RegistrationStatus> {
    const result:
      RegistrationStatus = await this.authService.updateUser(createUserDto);
    if (!result.success) {
      throw 'new HttpException(result.message, HttpStatus.BAD_REQUEST)';
    }
    return result;
  }
  @Post('activateOrDeactivateUser')
  async activateOrDeactivateUser(@Body() userReq: UserRequest): Promise<UserResponseModel> {
    try {
      return await this.authService.activateOrDeactivateUser(userReq);
    } catch (error) {
      return error;
      // return new ProjectsResponseModel(1234, 'hii');
    }
  }


  // @Post('getActiveUsersCount')  
  // public async getActiveUsersCount(): Promise<UserStatusWiseResponseModel> {
  //   // console.log(loginUserDto);
  //     return await this.authService.getActiveUsersCount();  
  // }

  @Post('getAllActiveUser')
  public async getAllActiveUser(): Promise<LoginUserDto> {
    // console.log(loginUserDto);
    return await this.authService.getAllActiveUser();
  }

  @Post('/deleteUser')
  public async deleteUser(@Body() createUserDto: updateUserDto): Promise<RegistrationStatus> {
    const result:
      RegistrationStatus = await this.authService.deleteUser(createUserDto);
    if (!result.success) {
      throw 'new HttpException(result.message, HttpStatus.BAD_REQUEST)';
    }
    return result;
  }
}
